import { signOut, useSession } from "next-auth/react";
import { FC, PropsWithChildren, useEffect } from "react";

interface AuthProviderProps { }


const AuthProvider: FC<PropsWithChildren<AuthProviderProps>> =
    ({ children }) => {
        const { data } = useSession();

        useEffect(() => {
            if (data?.error) {
                signOut();
            }
        }, [data])

        return (
            <>
                {children}
            </>
        );
    };

AuthProvider.displayName = "AuthProvider";
export default AuthProvider;